import React from 'react';
import { GridCell, CellType } from '../types';
import EditorCell from './EditorCell';

interface EditorRowProps {
  row: GridCell[];
  rowIndex: number;
  cols: number;
  onCellClick: (row: number, col: number) => void;
  activeTool: CellType;
}

const EditorRowComponent: React.FC<EditorRowProps> = ({ row, rowIndex, cols, onCellClick, activeTool }) => {
  return (
    <div
      className="grid gap-px"
      style={{ gridTemplateColumns: `repeat(${cols}, 3rem)` }}
      data-tool={activeTool}
    >
      {row.map((cell, colIndex) => (
        <EditorCell
          key={`cell-${rowIndex}-${colIndex}`}
          cell={cell}
          rowIndex={rowIndex}
          colIndex={colIndex}
          onClick={onCellClick}
        />
      ))}
    </div>
  );
};

// Custom memo to re-render only when shallow cell references in the row change
const areEqual = (prev: EditorRowProps, next: EditorRowProps) => {
  if (prev.rowIndex !== next.rowIndex || prev.cols !== next.cols) return false;
  if (prev.activeTool !== next.activeTool) return false; // re-render when tool changes
  if (prev.row.length !== next.row.length) return false;
  for (let i = 0; i < prev.row.length; i++) {
    if (prev.row[i] !== next.row[i]) return false; // re-render if any cell object changed
  }
  return true; // ignore onCellClick identity
};

export default React.memo(EditorRowComponent, areEqual);
